export const translations = {
	'Dashboard designer': {},
	'Save': {},
	'Save dashboard': {},
	'Name': {},
	'Description': {},
	'Full screen': {},
	'Dark theme': {},
	'The designer has failed to open': {},
};
